<template>
  <div class="campaign-preview-option" data-qa="sidebar-variant-selector">
    <h3>{{ $t('CampaignForm_Preview_Campaign_AB') }}</h3>
    <div class="variant-select-ct">
      <el-radio-group
        v-if="getVariants.length <= 4 && model.ab"
        class="radio-group"
        v-model="campaignVariant"
        @change="onChange"
        data-qa="sidebar-variant-radio-group"
      >
        <el-radio
          v-for="variant in getVariants"
          :key="variant.key"
          :label="variant.key"
          :data-qa="`sidebar-variant-radio-${variant.key}`"
        >
          {{ variantLabel(variant) }}
        </el-radio>
      </el-radio-group>
      <el-select
        v-else-if="getVariants.length > 4 && model.ab"
        v-model="campaignVariant"
        @change="onChange"
        data-qa="sidebar-variant-select"
      >
        <el-option
          v-for="variant in getVariants"
          :key="variant.key"
          :label="variantLabel(variant)"
          :value="variant.key"
        >
        </el-option>
      </el-select>
      <div v-else data-qa="sidebar-variant-static">
        {{ getVariants[0] ? variantLabel(getVariants[0]) : '' }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SidebarVariantSelector',

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      campaignVariant: 'A'
    }
  },

  computed: {
    getVariants() {
      return this.model.variants
    }
  },

  methods: {
    variantLabel(variant) {
      let label = this.$t('CampaignForm_Preview_Variant') + variant.key

      if (variant.title) {
        label += ' - ' + variant.title
      }

      return label
    },

    onChange(variantKey) {
      this.$emit('variant-change', variantKey)
    }
  }
}
</script>
<style scoped>
.variant-select-ct {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

h3 {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: #4b515f;
}

.campaign-preview-option {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 20px;
}

.radio-group {
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-size: 14px;
  line-height: 14px;
  color: #4b515f;
  padding-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/preview/SidebarVariantSelector.vue